
















import Vue from 'vue';
import Component from 'vue-class-component';
import BindAttrs from '@/utils/binds-attrs';
import {Prop} from 'vue-property-decorator';
import '@/compiled-icons/download';
import {PDFDocumentProxy, PDFPromise} from 'pdfjs-dist';
import PDFPage from '@/fields/pdf/AmetrasPdfPageContentTemplate.vue';
import {ResizeSensor} from 'css-element-queries';
import {throttle} from 'lodash';
import * as pdfjs from 'pdfjs-dist/webpack';
import {PDFPageProxy} from 'pdfjs-dist/webpack';

interface PageSetup {
  proxy: PDFPageProxy;
  scale: number;
}

@Component({
  mixins: [BindAttrs],
  components: {PDFPage},
})
export default class AmetrasPdfPageResizeWrapperTemplate extends Vue {
  @Prop({
    required: true
  }) pdf!: BufferSource;
  loading: boolean = false;
  pages: PageSetup[] = [];

  $refs!: {
    pdfWrapper: HTMLDivElement
  };

  mounted() {
    pdfjs.getDocument(this.pdf).promise.then((pdf) => {
      this.loadPdfPages(pdf);
      const resizeSensor = new ResizeSensor(this.$refs.pdfWrapper, throttle(() => {
        this.loadPdfPages(pdf);
      }, 500));
    });
  }

  private loadPdfPages(pdfStream: PDFDocumentProxy) {
    this.loading = true;
    const pageLoadPromises: Array<PDFPromise<any>> = [];
    for (let currentPageIndex = 1; currentPageIndex <= pdfStream.numPages; currentPageIndex++) {
      const currentPageLoadPromise = pdfStream.getPage(currentPageIndex);
      pageLoadPromises.push(currentPageLoadPromise);
      currentPageLoadPromise.then((loadedPage) => {
        const defaultViewPort = loadedPage.getViewport({scale: 1});
        const targetWidth = this.$refs.pdfWrapper.getBoundingClientRect().width;
        this.pages[loadedPage.pageIndex] = {
          scale: targetWidth / defaultViewPort.width,
          proxy: loadedPage
        };
      });
    }
    Promise.all(pageLoadPromises).then(() => {
      this.loading = false;
    });
  }
}
